import { render, staticRenderFns } from "./MarriageEnergyTwo.vue?vue&type=template&id=cc7cbb6c&"
import script from "./MarriageEnergyTwo.vue?vue&type=script&lang=js&"
export * from "./MarriageEnergyTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports